import { render, staticRenderFns } from "./ECommerceCleanDetail.vue?vue&type=template&id=04492506&scoped=true&"
import script from "./ECommerceCleanDetail.vue?vue&type=script&lang=js&"
export * from "./ECommerceCleanDetail.vue?vue&type=script&lang=js&"
import style0 from "./ECommerceCleanDetail.vue?vue&type=style&index=0&id=04492506&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04492506",
  null
  
)

export default component.exports